import * as React from "react";
import CurrencyDollar from "./currency-dollar.svg";
import DotsVertical from "./dots-vertical.svg";
import Edit from "./edit.svg";
import File02 from "./file-02.svg";
import MicrosoftAzureLogo from "./microsoftAzureLogo.svg";
import Home from "./home-02.svg";
import Logout from "./log-out-01.svg";
import Mail from "./mail.svg";
import Menu from "./menu-01.svg";
import ReportsW from "./reports-w.svg";
import Settings from "./settings.svg";
import UserCircle from "./user-circle.svg";
import { Icon as BaseIcon, IconProps as BaseIconProps } from "baseui/icon";
import { useStyletron } from "kanopi-components/theme/useStyletron";

export type IconProps = {
  icon: keyof typeof iconRegistry;
} & BaseIconProps;
export const Icon: React.FC<IconProps> = ({
  icon,
  color = "currentColor",
  size,
  ...restProps
}) => {
  const [, theme] = useStyletron();
  const IconComponent = iconRegistry[icon];

  return (
    <BaseIcon color={color} size={size || theme.sizing.scale800} {...restProps}>
      <IconComponent />
    </BaseIcon>
  );
};

const iconRegistry = {
  "currency-dollar": CurrencyDollar,
  "dots-vertical": DotsVertical,
  "file-02": File02,
  "home-02": Home,
  "log-out-01": Logout,
  "reports-w": ReportsW,
  "user-circle": UserCircle,
  menu: Menu,
  edit: Edit,
  settings: Settings,
  mail: Mail,
  microsoftAzureLogo: MicrosoftAzureLogo,
};
